// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q-item--active[data-v-1018193d]{font-weight:600}.guide-layout[data-v-1018193d]{display:flex;gap:32px;align-items:flex-start}.guide-layout__content[data-v-1018193d]{flex:1 1 auto;min-width:0}@media (max-width:900px){.guide-layout[data-v-1018193d]{flex-direction:column;gap:0}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
